<template>
  <DealTag :type />
</template>

<script lang="ts" setup>
import DealTag from '@backmarket/nuxt-layer-deals/DealTag.vue'

const { type } = defineProps<{ type: 'flash_sales' | 'seller_flash_sales' }>()
</script>
